// extracted by mini-css-extract-plugin
module.exports = {"patternSelector":"PatternSelector_patternSelector__1j-8F","patternSelectorHidden":"PatternSelector_patternSelectorHidden__3f48u"};